/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Imported_SuccessInputs */



/**
* | output |
* | --- |
* | "Translation imported successfully" |
*
* @param {Translation_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_imported_success = /** @type {((inputs?: Translation_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traduction importée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung erfolgreich importiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traduzione importata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перевод успешно импортирован.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Traducción importada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译已成功导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳が正常にインポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद सफलतापूर्वक आयात हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tradução importada com sucesso")
	return /** @type {LocalizedString} */ ("Translation imported successfully")
});